export const linguisticsConst = {
  path: "/single-programs/linguistics",
  title: "ФАКУЛЬТЕТ ГУМАНИТАРНЫХ НАУК – ЛИНГВИСТИКА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Лингвистика — понимание мира через язык</h2>
      <p>
        Лингвистика — это наука о структуре, функционировании и развитии языка. Программа объединяет теорию языка, практику перевода,
        межкультурную коммуникацию и современные технологии обработки текста и речи. Студенты осваивают как гуманитарные подходы, так и
        прикладные навыки для карьеры в образовании, IT и международной среде.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Фонетика, грамматика и лексикология</li>
        <li>Теория и практика перевода</li>
        <li>Сравнительно-историческое языкознание</li>
        <li>Межкультурная коммуникация и лингвокультурология</li>
        <li>Языковая политика и многоязычие</li>
        <li>Современные языковые технологии и корпусная лингвистика</li>
        <li>Локализация и адаптация контента</li>
        <li>Психолингвистика и нейролингвистика</li>
      </ul>
      <p>
        Программа включает языковую практику, работу с программами для перевода и локализации, а также стажировки в образовательных,
        переводческих и IT-компаниях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Переводчик и синхронист</li>
        <li>Преподаватель иностранных языков</li>
        <li>Специалист по локализации и адаптации</li>
        <li>Лингвист в IT-проектах (NLP, голосовые помощники)</li>
        <li>Редактор и специалист по контенту</li>
        <li>Консультант по межкультурной коммуникации</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€40,000 до €85,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, открывающий путь в международные компании и вузы</li>
        <li>Гибкие формы обучения: очно или дистанционно</li>
        <li>Обучение на русском и английском языках</li>
        <li>Практика перевода и проектная деятельность</li>
        <li>Поддержка языкового развития и цифровых навыков</li>
        <li>Консультации и сопровождение от приёмной комиссии</li>
      </ul>
      <p>Язык — это ключ к культуре, знанию и взаимопониманию. Мы учим владеть этим ключом профессионально.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам определиться с направлением, собрать документы и пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Лингвистика — понимание мира через язык
    Лингвистика — это наука о структуре, функционировании и развитии языка. Программа объединяет теорию языка, практику перевода, межкультурную коммуникацию и современные технологии обработки текста и речи. Студенты осваивают как гуманитарные подходы, так и прикладные навыки для карьеры в образовании, IT и международной среде.
    Что вы будете изучать?
    • Фонетика, грамматика и лексикология
    • Теория и практика перевода
    • Сравнительно-историческое языкознание
    • Межкультурная коммуникация и лингвокультурология
    • Языковая политика и многоязычие
    • Современные языковые технологии и корпусная лингвистика
    • Локализация и адаптация контента
    • Психолингвистика и нейролингвистика
    Программа включает языковую практику, работу с программами для перевода и локализации, а также стажировки в образовательных, переводческих и IT-компаниях.
    Кем можно работать после окончания?
    • Переводчик и синхронист
    • Преподаватель иностранных языков
    • Специалист по локализации и адаптации
    • Лингвист в IT-проектах (NLP, голосовые помощники)
    • Редактор и специалист по контенту
    • Консультант по межкультурной коммуникации
    Зарплата в Европе: от €40,000 до €85,000 в год
    Почему выбирают нас?
    • Европейский диплом, открывающий путь в международные компании и вузы
    • Гибкие формы обучения: очно или дистанционно
    • Обучение на русском и английском языках
    • Практика перевода и проектная деятельность
    • Поддержка языкового развития и цифровых навыков
    • Консультации и сопровождение от приёмной комиссии
    Язык — это ключ к культуре, знанию и взаимопониманию. Мы учим владеть этим ключом профессионально.

    Как поступить?
    Приёмная комиссия поможет вам определиться с направлением, собрать документы и пройти весь процесс поступления.
  `,
};
